import { setVisibility } from './notificationsSlice';

export const openNotificationPanel = () => {
  return async (dispatch) => {
    dispatch(setVisibility({ visibility: true }));
  };
};

export const closeNotificationPanel = () => {
  return async (dispatch) => {
    dispatch(setVisibility({ visibility: false }));
  };
};
